var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4191,
    cy: 13.0678,
    r: 3.56757,
    fill: "#13BD7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0676 17.5269C11.0973 17.5269 9.5 19.1241 9.5 21.0944V30.0133H13.0676V32.689V42.4998H16.6351V32.689H20.2027V42.4998H23.7703V32.689V27.3377V21.0944L33.5811 21.0944L33.5811 17.5269H23.7703H18.4189H13.0676Z",
    fill: "#13BD7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 11.5002H40.5C41.6046 11.5002 42.5 12.3957 42.5 13.5002V29.5002C42.5 30.6048 41.6046 31.5002 40.5 31.5002H26.2143",
    stroke: "#13BD7E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMain);
export default __webpack_public_path__ + "static/media/view-main.fc8bc52c413f9cedc942e5e21f476577.svg";
export { ForwardRef as ReactComponent };